export type LereDynamicPricingAuthSession = 'loggedIn' | 'loggedOut'

export const lereDecisionSessionState: Record<LereDynamicPricingAuthSession, { requested: boolean, completed: boolean }> = {
  loggedIn: { requested: false, completed: false },
  loggedOut: { requested: false, completed: false },
}

export function resetLereDecisionSessionState(authSession: LereDynamicPricingAuthSession): void {
  lereDecisionSessionState[authSession] = { requested: false, completed: false }
}
